import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Switch, Toast, Button, Dialog, Tabs } from 'antd-mobile-v5';
import { toWxMiniProgram } from '../../api/createHttpRequest';
import { withRouter } from 'react-router-dom';
import NoInventory from '../component/noInventory';
import styles from './index.module.scss';
import DoctorAvatar from '../../static/images/doctor_avatar.png';
import cure_suggestion from '../../static/images_cso/cure_suggestion.png';
import prescription_icon from '../../static/images_cso/prescription_icon.png';
import icon_search from '../../static/images_doctor/tool_introdce_search.png';
import icon_search_clear from '../../static/images_medicalLive/search_clear.png';
import no_cure_suggest from '../../static/images_cso/no_cure_suggest.png';
import right_arrow from '../../static/images_cso/right_arrow.png';
import right_arrow_home from '../../static/images_cso/right_arrow_home.png';
import arrow_down from '../../static/images_cso/search/arrow_down.png';
import to_file from '../../static/images_cso/search/to_file.png';
import icon_delete from '../../static/images_cso/search/icon_delete.png';
import is_selected from '../../static/images_cso/search/is_selected.png';
import special_selected from '../../static/images_cso/search/special_selected.png';
import excellent_selected from '../../static/images_cso/search/excellent_selected.png';
import star from '../../static/images_cso/search/star.png';
import un_star from '../../static/images_cso/search/un_star.png';
import abroad_medicine from '../../static/images_cso/search/abroad_medicine.png';

const api = new ApiCore();

let delayExcute:any = null;

const Search = (props: any) => {

    const [info, setInfo] = useState<any>({});
    const [searchKey, setSearchKey] = useState<any>(null);
    const [suggestTabs, setSuggestTabs] = useState<any>([]);
    const [activeSuggestIndex, setActiveSuggestIndex] = useState<any>(0);
    const [suggestReady, setSuggestReady] = useState(false);
    const [suggestList, setSuggestList] = useState<any>([]);
    const [treatmentPlans, setTreatmentPlans] = useState<any>([]);
    const [doctorInfo, setDoctorInfo] = useState<any>();
    const [projects, setProjects] = useState<any>([]);
    const [project, setProject] = useState<any>({});
    const noInventoryRef = useRef<any>();

    useEffect(() => {
        initData();
        return () => {
        }
    }, [])

    const initData = async () => {
        const data = await getInfo();
        setDoctorInfo(data);
        const _projects = data.projects || [];
        setProjects(_projects);
        // 新冠只配一个
        let _projects0 = (_projects && _projects[0]) || '';
        setProject(_projects0);
        api.getPlanPage({
            content: '',
            projectCode: _projects0.code,
            pageSize: 20
        }).then((res: any)=> {
            // getPlanPage
            if (res.code == 0) {
                setSuggestReady(true);
                setSuggestList(res.data?.rows || []);
            }
        })
    }

    const getInfo = () => {
        return new Promise<any>((resolve) => {
            api.getCsoDoctorInfo().then((res: any) => {
                if (res.code == 0) {
                    const _data = res.data || {};
                    resolve(_data);
                }
            });
        });
    }

    // 搜索标题变化
    const titleInput = (event: any) => {
        setSearchKey(event.target.value);
    }

    // 清除输入内容
    const clearInput = () => {
        setSearchKey('');
    }

    // 防抖搜索
    useEffect(() => {
        clearTimeout(delayExcute);
        if (searchKey !== null) {
            delayExcute = setTimeout(() => {
                searchSuggestList();
            }, 300);
        }
    }, [searchKey])

    const searchSuggestList = () => {
        setSuggestReady(false);
        api.getPlanPage({
            content: searchKey,
            projectCode: project.code,
            pageSize: 20
        }).then((res: any)=> {
            if (res.code == 0) {
                setSuggestReady(true);
                setSuggestList(res.data?.rows || []);
            }
        })
    }

    const onCureSuggestClick = async (val: any) => {
        let auditState = doctorInfo.state;
        let isGuest = false;
        let token = sessionStorage.getItem('token');
        if (token) {
            let tokens = JSON.parse(token);
            if (tokens.isGuest) {
                isGuest = true;
            }
        }
        if (isGuest) {
            // 游客
            const result = await Dialog.confirm({
                content: '您尚未授权登录，请前往授权登录后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/index/index?needLogin=1');
            }
        } else if (!isGuest &&(auditState !== 1 && auditState !== 4) ) {
            const result = await Dialog.confirm({
                content: '您尚有个人信息未完善，请先补全个人信息后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/csoComplete/csoComplete');
            } else {
                // 取消
            }
        } else {
            const params = {
                code: val.code
            }
            const medicineRes: any = await api.getPlanDetail(params);
            if (medicineRes.code == 0) {
                props.history.push(`/cso/doctor/covidSuggest?code=${val.code}&projectCode=${project.code || ''}&needAliasName=true&channelType=${val.channelType || ''}`);
            } else if (medicineRes.code == 70010100) {
                // 70010100 -> 暂无推荐的药品！
                noInventoryRef.current.toShow();
            } else {
                Toast.show(medicineRes.message);
            }
        }
    }

    const starChange = (e: any, index: any) => {
        e.stopPropagation();
        let _suggestList = suggestList.map((v: any) => v);
        _suggestList[index].isCollect = !_suggestList[index].isCollect;
        setSuggestList(_suggestList);
        // 更新
        api.getPlanCollect({
            treatmentPlanCode: _suggestList[index].code
        });
    }

    const CureCollectSuggestionRender = (val: any, index: number) => {
        return (
        <div className={styles.cure_suggestion} key={index}>
            {/* <div className={styles.cure_suggestion_top_img} >
                <img src={cure_suggestion} alt="" />
            </div> */}
            <div className={styles.cure_suggestion_content} >
                <div className={styles.head_b}>
                    <div className={styles.search_wrap}>
                            <div className={`${styles.tool_introduce_head}`}>
                                <div className={styles.search_head}>
                                    <div className={styles.search}>
                                        <img className={styles.search_img} src={icon_search} alt="" />
                                        <input type="text" placeholder="请输入商品名或通用名进行搜索" value={searchKey} autoFocus={true} onChange={(event) => { titleInput(event) }} />
                                        {
                                            searchKey &&
                                            <img className={`${styles.search_img_clear}`} src={icon_search_clear} alt="" onClick={ () => { clearInput() }} />
                                        }
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                
                <div className={styles.search_content}>
                    <div className={styles.search_content_title}>相关结果</div>
                    <div className={styles.search_content_r}>
                        {
                            suggestReady && suggestList.length == 0 &&
                            <div className={styles.search_no_content_wrap}>
                                <img src={no_cure_suggest} alt="" />
                                <div>
                                    暂无相关结果
                                </div>
                            </div>
                        }
                        {
                         suggestList.map((val: any, key: number) => (
                            <div key={key} className={`${styles.suggest_item}`}>
                                <div className={styles.search_content_r_1_wrap}>
                                    <img className={styles.search_content_r_1} src={val.icon || prescription_icon} alt="" />
                                    {
                                        val.channelType == 1 && 
                                        <img className={styles.search_content_r_1_1_b} src={abroad_medicine} alt="" />
                                    }   
                                </div>
                                {/* <img className={styles.search_content_r_1} src={prescription_icon} alt="" /> */}
                                <div  className={styles.search_content_r_2}>
                                    <div className={styles.search_content_r_2_t}>
                                        {
                                            val.pickType == 1 && 
                                            <img className={styles.special_selected} src={special_selected} alt="" />  
                                        }
                                        {
                                            val.pickType == 2 && 
                                            <img className={styles.special_selected} src={excellent_selected} alt="" />  
                                        }
                                       <span className={styles.title} >{val.drugName}</span>
                                    </div>
                                    <div className={styles.search_content_r_2_b}>{val.manufacturerName}</div>
                                    <div className={styles.search_content_r_2_b_b}>
                                        {/* <img className={styles.to_file} src={to_file} alt="" /> */}
                                        <div className={styles.medicine_price}>
                                            <span className={styles.unit}>¥</span>
                                            <span className={styles.price}>{val.price}</span>
                                        </div>
                                        <div className={styles.to_detail} onClick={() => { onCureSuggestClick(val) }}>查看详情</div>
                                    </div>
                                </div>
                                {/* <img className={styles.search_content_r_3} src={right_arrow_home} alt="" /> */}
                                <img className={styles.search_content_r_3} src={val.isCollect ? star : un_star} alt="" onClick={(e) => { starChange(e, key)}}/>
                            </div>
                        ))
                        }
                    </div>
                </div>
            </div>
        </div>)
    }

    const toUrl = (val: any) => {
        props.history.push(`/pages/index/index`);
    }

    return (
        <div className={styles.search_home_content}>
            {
                CureCollectSuggestionRender({
                    attributes: {},
                    type: "CureSuggestion",
                }, 1)
            }
            {/* <div className={styles.in_bottom}></div> */}
            <NoInventory ref={noInventoryRef} text='暂无库存，请选择其他药品'></NoInventory>
        </div>
    )
}

export default withRouter(Search);